'use client';

import { c as _c } from "react/compiler-runtime";
import { clsxm } from '../utils';
import { Body } from '../typography';
import { Button, FlexContainer } from '../components';
export interface SelectionActionBarProps {
  /** Number of currently selected rows. */
  selectedCount: number;
  /** Clears the current selection. */
  onClear: () => void;
  /** Action controls (buttons) that operate on the selection. */
  children?: React.ReactNode;
  /** Extra classes for outer spacing (e.g. margins). */
  className?: string;
}

/**
 * Toolbar shown above a selectable table. Always visible (so the feature is
 * discoverable and the table never shifts when a selection starts): it shows
 * the selected count and caller-supplied action controls, which stay put and
 * disable themselves when nothing is selected. `Clear` sits next to the count
 * so it never displaces the action controls on the right.
 */
export function SelectionActionBar(t0) {
  const $ = _c(16);
  const {
    selectedCount,
    onClear,
    children,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = clsxm("gap-3 rounded-md border border-border-secondary bg-background-secondary px-3 py-2", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== selectedCount) {
    t2 = <Body className="text-content-secondary" size="sm">{selectedCount} selected</Body>;
    $[2] = selectedCount;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== onClear || $[5] !== selectedCount) {
    t3 = selectedCount > 0 && <Button onClick={onClear} size="sm" variant="tertiary">Clear</Button>;
    $[4] = onClear;
    $[5] = selectedCount;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t2 || $[8] !== t3) {
    t4 = <FlexContainer className="gap-3" items="center">{t2}{t3}</FlexContainer>;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== children) {
    t5 = <FlexContainer className="gap-2" items="center">{children}</FlexContainer>;
    $[10] = children;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t1 || $[13] !== t4 || $[14] !== t5) {
    t6 = <FlexContainer className={t1} items="center" justify="between">{t4}{t5}</FlexContainer>;
    $[12] = t1;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
}